var _path, _path2, _path3, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordionTopscoreShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 192,
    viewBox: "0 0 163 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.591 28.0174V6.36934C64.946 3.18568 14.0089 16.5566 5.09583 35.0215C-6.36615 118.432 25.4698 170.006 78.3179 182.74V154.088C13.3722 150.904 -12.097 44.572 79.591 28.0174Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0438 28.0156V5.5466C98.6888 2.36293 148.353 16.3708 157.266 34.8357C172.549 118.43 136.892 170.641 84.0438 183.375V153.902C148.99 150.718 175.732 44.5702 84.0438 28.0156Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5 0C27.547 0 1.76281 30.2603 0.688222 31.5493C0.244363 32.0894 0.00132809 32.7648 0 33.462L0 93.7426C0 144.73 47.2458 175.002 67.5544 185.651C68.2577 185.974 69.0592 186.017 69.7935 185.771C70.5278 185.524 71.1389 185.008 71.5006 184.327C71.8623 183.646 71.9471 182.853 71.7374 182.112C71.5277 181.371 71.0396 180.738 70.3737 180.344C46.3463 167.747 6.03704 139.748 6.03704 93.7366V34.6011C10.275 30.0744 34.0006 7.03894 78.4815 6.03166V188.864C78.4811 189.473 78.6676 190.068 79.016 190.569C79.3645 191.07 79.8584 191.454 80.432 191.67C81.0056 191.885 81.6317 191.922 82.2269 191.776C82.8221 191.629 83.3583 191.306 83.7639 190.849C93.6465 186.628 163 154.785 163 92.9332V32.9763C163 32.2779 162.754 31.6014 162.306 31.0637C161.412 29.9904 139.884 4.83253 95.0471 0.341754C94.2525 0.270947 93.4615 0.511695 92.8433 1.01252C92.2251 1.51335 91.8287 2.23452 91.7388 3.02183C91.6987 3.41355 91.7367 3.80928 91.8507 4.18641C91.9646 4.56354 92.1522 4.91469 92.4028 5.2198C92.6534 5.52491 92.9621 5.778 93.3111 5.96463C93.6602 6.15125 94.0429 6.26775 94.4374 6.30747C132.392 10.1087 153.015 29.9605 156.963 34.1275V92.9332C156.963 146.607 100.438 176.567 84.5185 183.942V2.99785C84.5185 2.20277 84.2005 1.44025 83.6344 0.878049C83.0683 0.315844 82.3006 0 81.5 0Z",
    fill: "#151515"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.0129,
    cy: 90.8279,
    rx: 63.5597,
    ry: 63.2742,
    fill: "#A7E5E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionTopscoreShield);
export default __webpack_public_path__ + "static/media/accordion-topscore-shield.aa49e7df2180506ec8e377d6142a3371.svg";
export { ForwardRef as ReactComponent };